/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionAllowedActions
 */
export interface SubscriptionAllowedActions {
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    updatePaymentMethod: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    cancel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    restore: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    restoreWithNoTrial: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    addCustomerCredits: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    updateTrialPeriod: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    turnToPaid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    turnToFree: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    cancelAtEndOfPeriod: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAllowedActions
     */
    cancelScheduledCancellation: boolean;
}

/**
 * Check if a given object implements the SubscriptionAllowedActions interface.
 */
export function instanceOfSubscriptionAllowedActions(value: object): value is SubscriptionAllowedActions {
    if (!('updatePaymentMethod' in value) || value['updatePaymentMethod'] === undefined) return false;
    if (!('cancel' in value) || value['cancel'] === undefined) return false;
    if (!('restore' in value) || value['restore'] === undefined) return false;
    if (!('restoreWithNoTrial' in value) || value['restoreWithNoTrial'] === undefined) return false;
    if (!('addCustomerCredits' in value) || value['addCustomerCredits'] === undefined) return false;
    if (!('updateTrialPeriod' in value) || value['updateTrialPeriod'] === undefined) return false;
    if (!('turnToPaid' in value) || value['turnToPaid'] === undefined) return false;
    if (!('turnToFree' in value) || value['turnToFree'] === undefined) return false;
    if (!('cancelAtEndOfPeriod' in value) || value['cancelAtEndOfPeriod'] === undefined) return false;
    if (!('cancelScheduledCancellation' in value) || value['cancelScheduledCancellation'] === undefined) return false;
    return true;
}

export function SubscriptionAllowedActionsFromJSON(json: any): SubscriptionAllowedActions {
    return SubscriptionAllowedActionsFromJSONTyped(json, false);
}

export function SubscriptionAllowedActionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionAllowedActions {
    if (json == null) {
        return json;
    }
    return {
        
        'updatePaymentMethod': json['updatePaymentMethod'],
        'cancel': json['cancel'],
        'restore': json['restore'],
        'restoreWithNoTrial': json['restoreWithNoTrial'],
        'addCustomerCredits': json['addCustomerCredits'],
        'updateTrialPeriod': json['updateTrialPeriod'],
        'turnToPaid': json['turnToPaid'],
        'turnToFree': json['turnToFree'],
        'cancelAtEndOfPeriod': json['cancelAtEndOfPeriod'],
        'cancelScheduledCancellation': json['cancelScheduledCancellation'],
    };
}

export function SubscriptionAllowedActionsToJSON(json: any): SubscriptionAllowedActions {
    return SubscriptionAllowedActionsToJSONTyped(json, false);
}

export function SubscriptionAllowedActionsToJSONTyped(value?: SubscriptionAllowedActions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatePaymentMethod': value['updatePaymentMethod'],
        'cancel': value['cancel'],
        'restore': value['restore'],
        'restoreWithNoTrial': value['restoreWithNoTrial'],
        'addCustomerCredits': value['addCustomerCredits'],
        'updateTrialPeriod': value['updateTrialPeriod'],
        'turnToPaid': value['turnToPaid'],
        'turnToFree': value['turnToFree'],
        'cancelAtEndOfPeriod': value['cancelAtEndOfPeriod'],
        'cancelScheduledCancellation': value['cancelScheduledCancellation'],
    };
}

